import { useState, createContext, useContext } from 'react'

export const GlobalContext = createContext({})

export const GlobalProvider = ({
  children, value = null
}) => {
  const [global] = useState({ ...value })

  return <GlobalContext.Provider value={[global]}>{children}</GlobalContext.Provider>
}

export const useGlobal = () => useContext(GlobalContext)

export default {
  GlobalProvider,
  GlobalContext
}
